// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1upT7","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2yl_L"};